import * as Yup from 'yup';

export const sharedBasicSchema = {
    personalInformation: Yup.object().shape({
        name: Yup.string()
            .trim()
            .min(2, 'Imię musi zawierać minimum 2 litery.')
            .required('Pole wymagane'),
        surname: Yup.string().trim().required('Pole wymagane'),
        email: Yup.string().trim().email('Niepoprawny adres email').required('Pole wymagane'),
        phone: Yup.string().trim().required('Pole wymagane'),
        city: Yup.string()
            .trim()
            .min(2, 'Pole musi zawierać przynajmniej 2 znaki.')
            .required('Pole wymagane')
            .test('alphabets', 'Pole może zawierać tylko litery.', (value) =>
                /^[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ\s]+$/.test(value),
            ),
        zipCode: Yup.string()
            .trim()
            .required('Pole wymagane')
            .matches(/^\d{2}-\d{3}$/, 'Nieprawidłowy kod pocztowy'),
        address: Yup.string()
            .trim()
            .min(2, 'Nazwa ulicy musi zawierać minimum 2 litery')
            .required('Pole wymagane'),
        houseNumber: Yup.string().trim().required('Pole wymagane'),
    }),
    privacy: Yup.bool().oneOf([true], 'Pole wymagane'),
};
